(function () {
  function normalize(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function selectedVariantId(form) { var input = form && form.querySelector('[name="id"]'); return input && String(input.value || ''); }
  function setup(root) {
    if (root.__nsProtection) return;
    root.__nsProtection = true;
    var form = document.getElementById(root.dataset.formId) || root.closest('product-info, .product-info') && root.closest('product-info, .product-info').querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-ns-protection-option]'));
    var add = root.querySelector('[data-ns-protection-add]');
    var selection = root.querySelector('[data-ns-protection-selection]');
    var coreMessage = root.querySelector('[data-ns-protection-core-message]');
    var coreMatch = root.querySelector('[data-ns-protection-core-match]');
    function currentCore() {
      var id = selectedVariantId(form);
      var marker = Array.prototype.slice.call(root.querySelectorAll('[data-ns-protection-main-variant]')).find(function (item) { return item.dataset.nsProtectionMainVariant === id; });
      return marker ? marker.dataset.nsProtectionCore : '';
    }
    function selected() { return options.filter(function (option) { return option.classList.contains('is-selected') && !option.hidden; }); }
    function updateSummary() {
      var choices = selected();
      if (!choices.length) { selection.textContent = 'No protection selected. Your saber will be added on its own.'; add.hidden = true; return; }
      selection.textContent = choices.map(function (option) { return option.dataset.title; }).join(' · ') + ' selected.';
      add.hidden = false;
    }
    function updateCoreVisibility() {
      var rawCore = currentCore();
      var core = normalize(rawCore);
      var match = core.indexOf('neopixel') !== -1 ? 'neopixel' : core.indexOf('proffie') !== -1 ? 'proffie' : core.indexOf('srgb') !== -1 ? 's-rgb' : core.indexOf('baselit') !== -1 ? 'baselit' : '';
      var available = false;
      options.filter(function (option) { return option.dataset.category === 'core'; }).forEach(function (option) {
        var show = !!match && option.dataset.key === match;
        option.hidden = !show;
        if (!show) { option.classList.remove('is-selected'); option.setAttribute('aria-pressed', 'false'); }
        if (show) available = true;
      });
      root.dataset.coreState = available ? 'ready' : 'unavailable';
      coreMatch.textContent = available ? 'Your selected core is matched: ' + rawCore : 'No matching Core Care';
      coreMessage.hidden = available;
      if (!available) coreMessage.textContent = 'Select Baselit, S-RGB, Neopixel, or Proffie to view a matching Core Care option.';
      updateSummary();
    }
    function applyRecommendation() {
      var recommendation = normalize(root.dataset.hiltRecommendation);
      var autoSelect = root.dataset.hiltAutoSelect === 'true';
      var suggestedOption = null;
      options.filter(function (option) { return option.dataset.category === 'hilt'; }).forEach(function (option) {
        var suggested = !!recommendation && option.dataset.key === recommendation;
        if (suggested) suggestedOption = option;
        option.classList.toggle('is-recommended', suggested);
        var label = option.querySelector('[data-ns-protection-recommendation]');
        if (label) label.hidden = !suggested;
      });
      if (autoSelect && suggestedOption && !options.some(function (option) { return option.dataset.category === 'hilt' && option.classList.contains('is-selected'); })) {
        suggestedOption.classList.add('is-selected');
        suggestedOption.setAttribute('aria-pressed', 'true');
      }
    }
    options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        if (event.target.closest('[data-ns-protection-details]')) return;
        var category = option.dataset.category;
        if (category === 'core' || category === 'hilt') options.filter(function (item) { return item.dataset.category === category && item !== option; }).forEach(function (item) { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
        var next = !option.classList.contains('is-selected');
        option.classList.toggle('is-selected', next);
        option.setAttribute('aria-pressed', next ? 'true' : 'false');
        updateSummary();
      });
    });
    root.addEventListener('click', function (event) { if (event.target.closest('[data-ns-protection-details]')) event.stopPropagation(); });
    form.addEventListener('change', function () { window.setTimeout(updateCoreVisibility, 0); });
    add.addEventListener('click', function () {
      var extras = selected().map(function (option) { return { id: Number(option.dataset.variantId), quantity: 1, properties: { '_NS protection': 'true', '_NS protection for': selectedVariantId(form) } }; });
      if (!extras.length) return;
      if (window.NSNativePromo && typeof window.NSNativePromo.start === 'function') { window.NSNativePromo.start(form, extras); return; }
      add.disabled = true;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selectedVariantId(form)), quantity: Math.max(1, Number((form.querySelector('[name="quantity"]') || {}).value || 1)) }].concat(extras) }) }).then(function (response) { if (!response.ok) throw new Error(); window.location.assign('/cart'); }).catch(function () { add.disabled = false; });
    });
    applyRecommendation();
    updateCoreVisibility();
  }
  function start() { Array.prototype.slice.call(document.querySelectorAll('[data-ns-protection-picker]')).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();